<div class="main"
    [ngStyle]="{'width': ncWidth + 'px', 'border-width': borderWidth + 'px', 'border-color': ncBorderColor}">
    <div class="main-number" *ngIf="ncShowInfo" [ngStyle]="{'color': ncColor, 'fontSize': fontSize + 'px'}">
        {{ncPercent}}%
    </div>
    <div class="wave"
        [ngStyle]="{'width': ncWidth * 2 + 'px', 'top': ncWidth + 'px', 'background-color': ncWaveColor, 'animation-duration': speedType[ncSpeed] +'s'}">
    </div>
</div>